"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports.default = void 0;
var _react = require("@emotion/react");
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const styles = exports.styles = {
  default: theme => /*#__PURE__*/(0, _react.css)("position:relative;padding:30px 20px;border-radius:", theme.preemptionCardBorderRadius, ";background-color:#ffffff;overflow:hidden;" + (process.env.NODE_ENV === "production" ? "" : ";label:default;")),
  withHeader: process.env.NODE_ENV === "production" ? {
    name: "89cvcd",
    styles: "padding:0;padding-bottom:30px"
  } : {
    name: "j92l19-withHeader",
    styles: "padding:0;padding-bottom:30px;label:withHeader;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  },
  withHover: theme => /*#__PURE__*/(0, _react.css)("cursor:pointer;transition:all 0.3s ease-in-out;&:hover{background-color:#ffffff;box-shadow:", theme.shadowBig, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:withHover;")),
  shadow: theme => /*#__PURE__*/(0, _react.css)("box-shadow:", theme.shadowSmall, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:shadow;")),
  primary: theme => /*#__PURE__*/(0, _react.css)("background-color:", theme.primary, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:primary;")),
  gray: process.env.NODE_ENV === "production" ? {
    name: "e82xj7",
    styles: "background-color:rgba(0, 0, 0, 0.03)"
  } : {
    name: "uuazck-gray",
    styles: "background-color:rgba(0, 0, 0, 0.03);label:gray;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  },
  noPadding: process.env.NODE_ENV === "production" ? {
    name: "1hcx8jb",
    styles: "padding:0"
  } : {
    name: "c79p2l-noPadding",
    styles: "padding:0;label:noPadding;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  },
  largePadding: process.env.NODE_ENV === "production" ? {
    name: "186egwm",
    styles: "padding:2em"
  } : {
    name: "r98ymd-largePadding",
    styles: "padding:2em;label:largePadding;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  },
  nobackground: process.env.NODE_ENV === "production" ? {
    name: "1qsuvl4",
    styles: "background:transparent"
  } : {
    name: "m6erpp-nobackground",
    styles: "background:transparent;label:nobackground;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  },
  height: height => /*#__PURE__*/(0, _react.css)("height:", height, "px;" + (process.env.NODE_ENV === "production" ? "" : ";label:height;")),
  overflowvisible: process.env.NODE_ENV === "production" ? {
    name: "1h8nup8",
    styles: "overflow:visible"
  } : {
    name: "1fl3634-overflowvisible",
    styles: "overflow:visible;label:overflowvisible;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  }
};
var _default = exports.default = styles;